module.exports = __webpack_public_path__ + "img/IMG_8981_L_WoodMatted_MockedUp.ac0005fa.jpg";